import {gql} from "@apollo/client";

export const DELETE_JOB_STEP = gql`
	mutation postJobStep ($input: DeleteJobStepInput!) {
		deleteJobStep(input: $input) {boolean}
	}
`;
